import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home/home'
import newOrder from '@/views/newOrder/newOrder'
import contect from '@/views/contect/contect'
import user from '@/views/user/user'
import deliveryAddress from '@/views/deliveryAddress/deliveryAddress'
import customerList from '@/views/customerList/customerList'
import customerDetails from '@/views/customerDetails/customerDetails'
import subAccount from '@/views/subAccount/subAccount'
import fabricLibrary from '@/views/fabricLibrary/fabricLibrary'
import myOrder from '@/views/myOrder/myOrder'
import shippedOrders from '@/views/shippedOrders/shippedOrders'
import orderDetails from '@/views/myOrder/orderDetails'
import message from '@/views/message/message'
import billing from '@/views/billing/billing'
import shipment from '@/views/shipment/shipment'
import shipmentDetails from '@/views/shipment/shipmentDetails'
import underProduction from '@/views/underProduction/underProduction'
import successfully from '@/views/successfully/successfully'
import saveItems from '@/views/saveItems/saveItems'
import dressWell from '@/views/dressWell/dressWell'
import dressWellDetails from '@/views/dressWell/dressWellDetails'
import peofessionalOrder from '@/views/peofessionalOrder/peofessionalOrder.vue'
import allocationDetails from '@/views/allocationDetails/allocationDetails'
import quickOrder from '@/views/quickOrder/quickOrder'
import styleOrdering from '@/views/styleOrdering/styleOrdering'
import styleProduct from '@/views/styleOrdering/styleProduct'

Vue.use(Router)
//-- 解决点击相同路由报错问题
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//-- 解决点击相同路由报错问题
export default new Router({
  mode:'history',
  routes: [
    // 首页
    {
      path: '/',
      name: 'home',
      component: home
    },
    // 简单下单
    {
      path: '/quickOrder',
      name: 'quickOrder',
      component: newOrder,
      meta:{
        requireAuth:true
      }
    },
    // 联系我们
    {
      path: '/contect',
      name: 'contect',
      component: contect
    },
    // 用户中心
    {
      path: '/user',
      name: 'user',
      component: user,
      meta:{
        requireAuth:true
      }
    },
    // 审核中订单
    {
      path: '/shippedOrders',
      name: 'shippedOrders',
      component: shippedOrders,
      meta:{
        requireAuth:true
      }
    },
    // 地址
    {
      path: '/deliveryAddress',
      name: 'deliveryAddress',
      component: deliveryAddress,
      meta:{
        requireAuth:true
      }
    },
    // 客户列表
    {
      path: '/customerList',
      name: 'customerList',
      component: customerList,
      meta:{
        requireAuth:true
      }
    },
    // 客户详情
    {
      path: '/customerDetails',
      name: 'customerDetails',
      component: customerDetails,
      meta:{
        requireAuth:true
      }
    },
    // 子账户
    {
      path: '/subAccount',
      name: 'subAccount',
      component: subAccount,
      meta:{
        requireAuth:true
      }
    },
    // 面料列表
    {
      path: '/fabricLibrary',
      name: 'fabricLibrary',
      component: fabricLibrary
    },
    // 我的订单
    {
      path: '/myOrder',
      name: 'myOrder',
      component: myOrder,
      meta:{
        requireAuth:true
      }
    },
    // 订单详情
    {
      path: '/orderDetails',
      name: 'orderDetails',
      component: orderDetails,
      meta:{
        requireAuth:true
      }
    },
    // 消息中心
    {
      path: '/message',
      name: 'message',
      component: message,
      meta:{
        requireAuth:true
      }
    },
    // 物流中心
    {
      path: '/shipment',
      name: 'shipment',
      component: shipment,
      meta:{
        requireAuth:true
      }
    },
    // 物流中心详情
    {
      path: '/shipmentDetails',
      name: 'shipmentDetails',
      component: shipmentDetails,
      meta:{
        requireAuth:true
      }
    },
    // 账单列表
    {
      path: '/billing',
      name: 'billing',
      component: billing,
      meta:{
        requireAuth:true
      }
    },
    // 生产不足列表
    {
      path: '/underProduction',
      name: 'underProduction',
      component: underProduction,
      meta:{
        requireAuth:true
      }
    },
    // 成功
    {
      path: '/successfully',
      name: 'successfully',
      component: successfully,
      meta:{
        requireAuth:true
      }
    },
    // 快速下单
    {
      path: '/newOrder',
      name: 'newOrder',
      component: quickOrder,
      meta:{
        requireAuth:true
      }
    },
    // 购物车
    {
      path: '/saveItems',
      name: 'saveItems',
      component: saveItems,
      meta:{
        requireAuth:true
      }
    },
    // 专业下单
    {
      path: '/peofessionalOrder',
      name: 'peofessionalOrder',
      component: peofessionalOrder,
      meta:{
        requireAuth:true
      }
    },
    // dressWell
    {
      path: '/dressWell',
      name: 'dressWell',
      component: dressWell,
      meta:{
        // requireAuth:true
      }
    },
    // dressWell详情
    {
      path: '/dressWellDetails',
      name: 'dressWellDetails',
      component: dressWellDetails,
      meta:{
        // requireAuth:true
      }
    },
    // 子账号使用情况
    {
      path: '/allocationDetails',
      name: 'allocationDetails',
      component: allocationDetails,
      meta:{
        requireAuth:true
      }
    },
    // 款式下单详情
    {
      path: '/styleOrdering',
      name: 'styleOrdering',
      component: styleOrdering,
      meta:{
        requireAuth:true
      }
    },
    // 款式下单产品列表
    {
      path: '/styleProduct',
      name: 'styleProduct',
      component: styleProduct,
      meta:{
        requireAuth:true
      }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js